import { Controller } from "@hotwired/stimulus";
import { Shortcuts } from "shortcuts";

// Connects to data-controller="global-shortcuts"
export default class extends Controller {
  connect() {
    this.shortcuts = new Shortcuts({
      shouldHandleEvent: (event) => {
        // only handle if no element has focus
        return event.target.tagName === "BODY";
      },
    });
    console.log("global shortcuts controller connected️");

    this.shortcuts.add([
      { shortcut: "g h", handler: () => this.linkShortcut("home") },
      { shortcut: "g d", handler: () => this.linkShortcut("dashboard") },
      { shortcut: "g j", handler: () => this.linkShortcut("jobs") },
      { shortcut: "g a", handler: () => this.linkShortcut("agents") },
      { shortcut: "g n", handler: () => this.linkShortcut("network") },

      { shortcut: "g b", handler: () => this.linkShortcut("back") },

      { shortcut: "1", handler: () => this.tab(1) },
      { shortcut: "2", handler: () => this.tab(2) },
      { shortcut: "3", handler: () => this.tab(3) },
      { shortcut: "4", handler: () => this.tab(4) },
      { shortcut: "5", handler: () => this.tab(5) },

      { shortcut: "/", handler: () => this.focusElement("list-filter") },

      { shortcut: "c", handler: () => this.linkShortcut("add") },
      { shortcut: "e", handler: () => this.linkShortcut("edit") },
      { shortcut: "s", handler: () => this.linkShortcut("star") },

      { shortcut: "v", handler: () => this.linkShortcut("open-job-link") }, // v for View job post
      { shortcut: "y", handler: () => this.linkShortcut("open-job-link") }, // y for applY
      {
        shortcut: "t",
        handler: () => this.linkShortcut("open-agent-or-agency"),
      }, // t for Through agent/agency

      {
        shortcut: "i",
        handler: () => this.linkShortcut("open-linked-in-profile"),
      }, // i for linkedIn
    ]);
  }

  disconnect() {
    this.shortcuts.reset();
    console.log(
      "global shortcuts controller disconnected - global shortcuts reset",
    );
  }

  linkShortcut(action) {
    console.log(`shortcut for ${action}`);
    const link = document.querySelector(`[data-shortcut='${action}']`);
    if (link) {
      console.log(`Using shortcut to navigate to ${link.href}`);
      link.click();
    }
    return true;
  }

  tab(tabNumber) {
    console.log(`shortcut for tab ${tabNumber}`);
    const tabs = document.getElementById("tabLinks");

    if (tabs) {
      const links = tabs.querySelectorAll("a");
      console.log(links);
      if (tabNumber <= links.length) {
        const link = links[tabNumber - 1];
        console.log(`Using shortcut to navigate to ${link.href}`);
        link.click();
      } else {
        console.log("no matching tab");
      }
    } else {
      console.log("no tabs on current page");
    }
  }

  focusElement(elementId) {
    console.log("Trying to focus on ", elementId);
    const el = document.getElementById(elementId);

    if (el) {
      el.focus();
    }

    return true;
  }
}
